import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { I18nProvider } from '../_theme/i18n/i18nProvider'
import { LayoutProvider, LayoutSplashScreen } from '../_theme/layout/core'
import { MasterInit } from '../_theme/layout/MasterInit'
import { AuthInit } from './modules/auth'
import { ThemeModeProvider } from '../_theme/partials/layout/theme-mode/ThemeModeProvider'
import store from '../redux/store'
import { Provider } from 'react-redux';
import { LocationInit } from '../_theme/layout/components/LocationInit'
import { useJsApiLoader } from '@react-google-maps/api'
import { envConfig } from '../utils/config'
import SimpleLoader from './modules/apps/components/SimpleLoader'
import ChatbotWidget from './PublicPages/Components/chatbotWidget'

const App = () => {
  const libraries: ("places")[] = ["places"];

  let { isLoaded } = useJsApiLoader({
    googleMapsApiKey: envConfig.GOOGLE_MAPS_API_KEY,
    libraries
  });
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Provider store={store}>
        <LocationInit />
        <I18nProvider>
          <LayoutProvider>
            <ThemeModeProvider>
              <AuthInit>
                {isLoaded && <Outlet />}
                <MasterInit />
                <ChatbotWidget />
              </AuthInit>
            </ThemeModeProvider>
          </LayoutProvider>
        </I18nProvider>
      </Provider>
    </Suspense>
  )
}

export { App }
